module.exports = __webpack_public_path__ + "static/img/1438_phase_function_Paper_Points.bfab064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1438_phase_function_Paper_Points.png
// module id = xrYY
// module chunks = 0